import React, { useState } from "react";
import styled from "styled-components";
import Auxiliary from "util/Auxiliary";
import ModuleBreadcrumb from "components/Common/ModuleBreadcrumb";
import { Button, Col, Modal, Row } from "antd";
import Birthday_bg from "../../assets/images/birthday_bg.jpg";
import { EyeOutlined } from "@ant-design/icons";
import Birthday_modal from "./Birthday_modal";

const EventPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const onCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <EventStyle>
      <Auxiliary>
        <ModuleBreadcrumb
          title="Nikol Bal-Sabha Event"
          breadcrumbs={["Event", "View"]}
          links={["/event", "/event", ""]}
        />
        <Row className="gx-profile-content">
          <Col span={24}>
            <div className="gx-card">
              <div className="gx-card-body">
                <div className="birthday-bg">
                  <div className="birthday-text">Birthday Notify</div>
                  <Button
                    className="btn-view"
                    icon={<EyeOutlined />}
                    onClick={() => showModal()}
                  >
                    View
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Modal
          title="Birthday Details"
          visible={isModalVisible}
          onCancel={onCancel}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
        >
          <Birthday_modal />
        </Modal>
      </Auxiliary>
    </EventStyle>
  );
};

const EventStyle = styled.div`
  font-family: "Cabin", sans-serif;
  .birthday-bg {
    position: relative;
    background-image: url(${Birthday_bg});
    background-size: 329px;
    height: 176px;
    width: 329px;
    border-radius: 20px;
    filter: saturate(1);
    border: 1px solid skyblue;
  }
  .birthday-text {
    font-size: 26px;
    font-weight: 900;
    color: #203c72;
    padding: 51px 0 10px 28px;
  }
  .cake-gif {
    height: 100px;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .btn-view {
    background: #203c72;
    color: #fff;
    margin-left: 28px;
    border-radius: 8px;
  }
  .btn-view:hover {
    border: 1px solid #203c72;
    color: #203c72;
  }
`;

export default EventPage;
